<template>
  <div class="upload-field">
    <div v-if="newValue && imgPath" class="upload-field__img-wrapper">
      <img :src="imgPath" alt="" :class="imgClasses" :style="imgStyles" />
    </div>
    <div v-if="newValue" class="upload-field__default-value">
      <strong>{{ defaultFileNameLabel }} </strong>
      <m4-button v-if="downloadLink" tag="a" variant="primary-text" :href="downloadLink">
        <m4-icon icon="download"></m4-icon> {{ newValue }}
      </m4-button>
      <span v-else>{{ newValue }}</span>
      <m4-button v-if="showRemoveIcon" variant="danger-link" tag="a" size="sm" circle @click="removeDefaultFile">
        <m4-icon icon="close" class="btn__icon"></m4-icon>
      </m4-button>
    </div>
    <div class="upload-field__file-input-note">{{ labelFileInput }}</div>
    <m4-input :name="hiddenInputName" type="hidden" :value="hiddenFieldValue"></m4-input>
    <m4-input v-if="defaultInputId" :name="hiddenInputId" type="hidden" :value="defaultInputId"></m4-input>
    <m4-file-input v-bind="$attrs"></m4-file-input>
  </div>
</template>

<script>
export default {
  name: "M4UploadField",
  data() {
    return {
      newValue: this.defaultFileName,
      hiddenFieldValue: this.defaultFileName
    };
  },
  props: {
    showRemoveIcon: {
      type: Boolean,
      default: true
    },
    defaultFileNameLabel: {
      type: String,
      default: "Uploaded:"
    },
    defaultFileName: {
      type: String
    },
    defaultInputName: {
      type: String
    },
    defaultInputId: {
      type: String
    },
    defaultInputValueDeleted: {
      type: String,
      default: ""
    },
    labelFileInput: {
      type: String,
      default: "Replace uploaded document with:"
    },
    imgPath: {
      type: String
    },
    imgWidth: {
      type: [String, Number]
    },
    imgCircle: {
      type: Boolean
    },
    downloadLink: {
      type: String
    }
  },
  computed: {
    imgClasses() {
      let classes = ["upload-field__img-wrapper__img"];
      if (this.imgCircle) {
        classes.push("upload-field__img-wrapper__img--rounded");
      }
      return classes;
    },
    hiddenInputName() {
      if (this.defaultInputName) {
        return this.defaultInputName;
      }
      return this.$attrs.name + "__default";
    },
    hiddenInputId() {
      return this.$attrs.name + "__id";
    },
    imgStyles() {
      return this.imgWidth ? { width: this.imgWidth + "px" } : {};
    }
  },
  methods: {
    removeDefaultFile() {
      this.newValue = null;

      if (this.defaultInputValueDeleted) {
        this.hiddenFieldValue = this.defaultInputValueDeleted;
      } else {
        this.hiddenFieldValue = this.newValue;
      }
    }
  }
};
</script>
